import { createFileRoute } from '@tanstack/react-router';
import { ContactSection } from '../../components/contacts/ContactSection';

export const Route = createFileRoute('/_auth/vendors')({
  component: () => <ContactSection contactType="vendor" titlePlural="Vendors" titleSingular="vendor" />,
});
